export default {
    getvideoSECTION_ID(state) {
        return state.videoSECTION_ID
      },
  }
  